import { createSlice } from '@reduxjs/toolkit';

const alertSlice = createSlice({
  name: 'alert',
  initialState: {
    isShow: false,
    isDimed: false,
    message: [],
    callback: () => {},
    isDelCloseButton: false,
  },
  reducers: {
    open: (state, { payload: { message, callback, isDelCloseButton, isDimed } }) => {
      state.isShow = true;
      state.message = message;
      state.callback = callback || (() => {});
      state.isDelCloseButton = isDelCloseButton;
      state.isDimed = isDimed || false;
    },
    close: state => {
      state.isShow = false;
    },
  },
});

export const { open, close } = alertSlice.actions;
export default alertSlice.reducer;
